import { Star } from "lucide-react"

import { categories } from "@/data/categories"
import { icons } from "@/data/icons"


export const getIconComponent = (iconName: string) => {
  const found = icons.find((i) => i.value === iconName)
  if (found) {
    const IconComponent = found.icon
    return <IconComponent className="h-5 w-5" />
  }
  return <Star className="h-5 w-5" />
}

export const getCategoryDisplayName = (category: string) => {
  if (category === "todas") return "Todas"
  const found = categories.find((cat) => cat.value === category)
  return found ? found.label : category.charAt(0).toUpperCase() + category.slice(1)
}

export function formatDayMonth(dateString: string) {
  const [year, month, day] = dateString.split("-")

  const date = new Date(Number(year), Number(month) - 1, Number(day)) // <- local, sem UTC

  const formattedDay = date.toLocaleDateString("pt-BR", { day: "2-digit" })
  const formattedMonth = date
    .toLocaleDateString("pt-BR", { month: "short" })
    .replace(".", "")
    .replace(/^\w/, c => c.toUpperCase())

  return { day: formattedDay, month: formattedMonth }
}